import {
    AreaCode,
    areaCodeSchema,
    ElectionDataResponse,
} from '@west-australian-newspapers/election-api-types'
import { ElectionMeta } from '@west-australian-newspapers/publication-types'

export type LowercaseElectionAreaCode = Lowercase<AreaCode>

/** The logo will fallback to mobile if desktop is not provided. */
export type ElectionLogo = {
    /** An image uri. */
    mobile: string
    /** An image uri. */
    desktop?: string
    /** A human readable description for screen-readers. */
    alt?: string
}

export type UnloadedElectionDefinition = {
    electionData: undefined
    electionId: string
    logo: ElectionLogo
    meta: ElectionMeta
}

export type LoadedElectionDefinition = {
    electionData: ElectionDataResponse
    electionId: string
    logo: ElectionLogo
    meta: ElectionMeta
}

/** Contains all the data relevant to an election. */
export type ElectionDefinition =
    | UnloadedElectionDefinition
    | LoadedElectionDefinition

/** Decipher the wan election id into a consumable value. */
export const getElectionDataFromWanId = (
    wanElectionId: string,
): { areaCode: LowercaseElectionAreaCode; year: number } => {
    const splitId = wanElectionId.split('-')
    const [areaCode, _, year] = splitId

    if (!areaCode || !year) {
        throw new Error(`Invalid election id provided: ${wanElectionId}`)
    }

    if (areaCode === 'federal') {
        return {
            areaCode: 'federal',
            year: Number(year),
        }
    } else {
        const state = areaCode.toLowerCase()

        if (!areaCodeSchema.safeParse(areaCode.toUpperCase()).success) {
            throw new Error(`Invalid state provided: ${state}`)
        }

        return {
            areaCode: state as LowercaseElectionAreaCode,
            year: Number(year),
        }
    }
}
